export const getPageName = () => {
  let pageName = window.location.pathname || ""
  if (pageName === "/") pageName = "Home"
  return pageName.charAt(0).toUpperCase() + pageName.slice(1)
}



// WEBPACK FOOTER //
// ./src/utils/page.js